// src/pages/NotFound.js
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Button, Typography } from '@mui/material';
import StatusPage from '../components/StatusPage';
import { useSeo } from '../seo';

/**
 * Firebase rewrites every unmatched path to index.html, so an address that
 * does not exist still answers 200. Google calls that a soft 404 and wastes
 * crawl budget on it. Returning a real 404 status would need server-side
 * routing; the noindex here is what keeps these pages out of the index in the
 * meantime.
 */
const NotFound = () => {
  useSeo({
    title: 'Page not found | Crestancia',
    description: 'This page does not exist.',
    path: '/404',
    noindex: true,
  });

  return (
    <StatusPage
      tone="warning"
      title="Page not found"
      actions={
        <Button
          component={RouterLink}
          to="/home"
          variant="contained"
          disableElevation
          sx={{ px: 4, py: 1.4, borderRadius: 999, fontWeight: 700, textTransform: 'none' }}
        >
          Back to the shop
        </Button>
      }
    >
      <Typography>
        That address does not exist. It may have been moved, or the link that brought you here
        may be out of date.
      </Typography>
    </StatusPage>
  );
};

export default NotFound;
